import styled from 'styled-components';
import { Label as LabelBase } from '@student-coin/coinpaper-components';

export const Label = styled(LabelBase)``;
